import * as constants from "./constants";

const initialState = {
  allNotifications: {
    notification_templates: [],
    template_macros: [],
    notificationHistoryList: [],
    loading: false,
  },
  error: null,
};

const notificationManagerReducer = (state = initialState, action) => {
  switch (action.type) {
    case constants.FETCH_NOTIFICATION_TEMPLATES_LIST:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case constants.FETCH_NOTIFICATION_TEMPLATES_LIST_SUCCESS:
      return {
        ...state,
        allNotifications: action.payload,
        loading: false,
        error: null,
      };

    case constants.FETCH_NOTIFICATION_TEMPLATES_LIST_FAILURE:
      return {
        ...state,
        error: action.error,
      };

    //add
    case constants.SEND_NOTIFICATION:
      return {
        ...state,
        loading: true,
        error: null,
        // createUserLoading: true,
      };

    case constants.SEND_NOTIFICATION_SUCCESS:
      return {
        ...state,
        loading: false,
        notificationResponse: action.payload,
      };

    case constants.FETCH_NOTIFICATION_HISTORY:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case constants.FETCH_NOTIFICATION_HISTORY_SUCCESS:
      return {
        ...state,
        loading: false,
        notificationHistoryList: action.payload,
      };

    default:
      return state;
  }
};

export default notificationManagerReducer;
